import "./EditSiteContactInformation.html";
import "./EditSiteContactInformation.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditSiteContactInformationComponentController from "./EditSiteContactInformationComponentController";

export default class EditSiteContactInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditSiteContactInformationComponentController;
        this.templateUrl =
            "/App/Components/Site/Overview/" +
            "ContactInformation/EditSiteContactInformation/EditSiteContactInformation.html";
    }
}

module("mmManagePortal").component("mmEditSiteContactInformation", new EditSiteContactInformationComponent());
